var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414 828",
    style: {
      enableBackground: "new 0 0 414 828"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.376 683.076h331.2v-558.9h-331.2v558.9zm165.6 103.5c-17.112 0-31.05-13.938-31.05-31.05 0-17.112 13.938-31.05 31.05-31.05s31.05 13.938 31.05 31.05c0 17.181-13.869 31.05-31.05 31.05zm-67.275-734.85h134.55c8.556 0 15.525 6.969 15.525 15.525 0 8.556-6.969 15.525-15.525 15.525h-134.55c-8.556 0-15.525-6.969-15.525-15.525 0-8.556 7.038-15.525 15.525-15.525zM331.176-.024h-248.4c-45.747 0-82.8 37.053-82.8 82.8v662.4c0 45.747 37.053 82.8 82.8 82.8h248.4c45.747 0 82.8-37.053 82.8-82.8v-662.4c0-45.678-37.053-82.8-82.8-82.8z"
  })));
};

export default SvgDeviceMobile;